"use strict";

import angular from "angular";

import { isSamePage } from "../../services/table-search.service";
import template from "./search-input.component.html";
import "./search-input.component.scss";

export class SearchInputComponent {
    constructor($rootScope, LayoutService, TableSearchService) {
        this.$rootScope = $rootScope;
        this.LayoutService = LayoutService;
        this.TableSearchService = TableSearchService;

        this.searchText = "";
    }

    $onInit() {
        this.searchText = this.TableSearchService.get();

        this.$rootScope.$on(
            "$locationChangeSuccess",
            (event, next, current) => {
                // Mesma regra do `TableSearchService`: trocar só a query (a aba do filtro rápido)
                // não é sair da tela, e o texto tem de continuar à vista enquanto filtra a lista.
                if (!isSamePage(next, current)) {
                    this.searchText = "";
                }
            }
        );

        // O texto exibido é uma cópia local. Quem limpa a busca de fora (um "limpar filtros" na
        // tela, por exemplo) avisa por aqui — do contrário o campo segue mostrando um termo que
        // já não está mais aplicado na lista.
        this.$rootScope.$on("onResetHeaderInput", () => {
            this.searchText = "";
        });
    }

    onSearch() {
        this.TableSearchService.set(this.searchText);
        this.$rootScope.$broadcast("onTypeHeaderInput", {
            searchText: this.searchText
        });
    }
}

SearchInputComponent.$inject = [
    "$rootScope",
    "LayoutService",
    "TableSearchService"
];

const name = "searchInputComponent";
const def = {
    controller: SearchInputComponent,
    bindings: {
        placeholder: "@"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
